import { type ApiResult, type BaseParams, links, type PostParams, Request } from '@app/client';

interface SegmentTrackingRequest {
    event: string;
    properties: Record<string, string | number | null>;
    type: string;
    timestamp: Date;
    context: {
        userAgent: string;
        app: { version: string };
    };
}

interface SegmentPageRequest {
    event: string;
    properties: Record<string, string | number | null>;
    category?: string;
    page: string;
    type: string;
    timestamp: Date;
    options: { integrations: Record<string, boolean | string | number> };
}

export async function trackEvent(params: BaseParams & PostParams<SegmentTrackingRequest>): Promise<ApiResult<void>> {
    return Request.postRequest<void>({
        ...params,
        target: links.segemnt().event(),
        value: {
            ...params.value,
        },
    });
}

export async function trackPage(params: BaseParams & PostParams<SegmentPageRequest>): Promise<ApiResult<void>> {
    return Request.postRequest<void>({
        ...params,
        target: links.segemnt().event(),
        value: {
            ...params.value,
        },
    });
}
